// Angular
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

// Afidium
import { ISectorStay } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { Yii } from 'libraries/interfaces/Yii';

//libs
import { faBed, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'table-sector-stay-summary',
    template: `
        <div class="sectors-container">
            <div class="flex-1">
                <div class="name">
                    <fa-icon [icon]="iconBed" class="icon-bed"></fa-icon>
                    <strong class="main-information">{{name}}</strong>
                </div>

                <div class="sectors-list">
                    <stay-summary [sector]="sector" [showIcon]="false"></stay-summary>
                </div>
            </div>

            <ng-content></ng-content>
        </div>
    `,
    styles: [`
        .sectors-container {
            display: flex;
            align-items: baseline;
        }

        .icon-bed {
            margin-right: .75rem;
        }
        .sectors-list {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
        }
        .icon-info {
            color: #337ab7;
            cursor: pointer;
        }
        .name {
            margin-bottom: .75rem;
        }

        .flex-1 {
            flex: 1;
        }
    `]
})

export class TableSectorStaySummaryComponent implements OnChanges {
    @Input()
    public sector: ISectorStay;

    public name: string;

    public iconBed: IconDefinition = faBed;

    public ngOnChanges(changes: SimpleChanges): void {
        this.name = this.sector && this.sector.in && this.sector.in.location && this.sector.in.location.name || Yii.t('wui-shared-js', "Hotel");
    }
}